import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "./style.scss";
import { GptMCQQuestion } from "../../Models/Chat";

interface MultipleChoiceQuestionProps {
    data: string,
    scrollToBottom: () => void
}

const MultipleChoiceQuestion: React.FC<MultipleChoiceQuestionProps> = ({ data, scrollToBottom }) => {
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [mcqData, setMcqData] = useState<GptMCQQuestion | null>(null);
    const [mcqError, setMcqError] = useState<string>("");

    const handleOptionClick = (optionKey: string) => {
        setSelectedOption(optionKey);
        setIsCorrect(Boolean(mcqData?.options[optionKey]?.is_correct));
        scrollToBottom();
    };

    useEffect(() => {
        try {
            const parsedData = JSON.parse(data);
            setMcqData(parsedData);
        } catch (error) {
            setMcqError(data);
        }

        return () => {
            setMcqData(null);
            setMcqError("");
        };
    }, [data]);

    return (
        <>
            {mcqData ? (
                <>
                    <div>
                        <p>{mcqData.question}</p>
                        {Object.keys(mcqData.options).map((key) => (
                            <div key={key}>
                                <button
                                    className={`mult-choice-option ${selectedOption === key ? "selected" : ""
                                        }`}
                                    onClick={() => handleOptionClick(key)}>
                                    {mcqData.options[key].Text}
                                </button>
                            </div>
                        ))}

                        {selectedOption && (
                            <>
                                <div className="divider"></div>
                                <div
                                    className={`explanation-section ${selectedOption &&
                                        mcqData.options[selectedOption]
                                            .is_correct
                                        ? "correct"
                                        : "incorrect"
                                        }`}>
                                    <p>
                                        {mcqData.options[selectedOption]
                                            .is_correct ? (
                                            <span className="correct-text">
                                                {" "}
                                                <FaCheckCircle /> Correct!
                                            </span>
                                        ) : (
                                            <span className="wrong-text">
                                                {" "}
                                                <FaTimesCircle /> Incorrect. Try
                                                again
                                            </span>
                                        )}
                                    </p>
                                    {isCorrect && <p>{mcqData.explanation}</p>}
                                </div>
                            </>
                        )}
                    </div>
                </>
            ) : (
                <>{mcqError}</>
            )}
        </>
    );
};

export default MultipleChoiceQuestion;
